import React, { Component } from 'react';
import { Upload, message, DatePicker, Button, Icon } from 'antd';
import moment from "moment";

const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        loading: false,
        fileList: []
    }
    render() {
        const { date, loading, fileList } = this.state;
        const that = this;
        const props = {
            name: 'file',
            action: '/targetExcel',
            accept: ".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            headers: {
                authorization: 'authorization-text',
            },
            data: {
                month: moment(date).format('M'),
                year: moment(date).format('YYYY'),
            },
            fileList,
            onChange(info) {
                that.setState({ fileList: [info.file], loading: true });
                if (info.file.status === 'done') {
                    if (info.file.response.status == 1) {
                        message.success(`${date} 数据已经更新成功！`);
                    } else {
                        message.error(`${date} 更新失败，请重新上传或联系管理员！`);
                    }
                    that.setState({ loading: false, });
                    return
                } else if (info.file.status === 'error') {
                    message.error(`表格上传失败！`);
                    that.setState({ loading: false, });
                }
            },
        };
        return (
            <div className="list">
                <div className="title">
                    Corporate Office Target 集团指标
                </div>
                <MonthPicker
                    placeholder="请选择年月"
                    monthCellContentRender={(date, local) => {
                        return moment(date).format('M月')
                    }}
                    defaultValue={moment(this.state.date, "YYYY-MM")}
                    format="YYYY-MM"
                    onChange={(date, str) => {
                        this.setState({ date: str });
                    }}
                />
                <Upload {...props}>
                    <Button
                        loading={loading}
                    >
                        <Icon type="upload" /> {loading ? '文件上传中。。。' : "上传"}
                    </Button>
                </Upload>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/guestReviewImport/Target.js